import { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { LOGO_URL_LIGHT } from '../../constants';
import { SERVICE_LINKS, NAV_LINKS, BOOK_CTA } from './navConfig';
import { trackAssessmentClick } from '../../lib/analytics';

export const RedesignHeader = () => {
  const [open, setOpen] = useState(false);
  const [svcOpen, setSvcOpen] = useState(false);
  const close = () => { setOpen(false); setSvcOpen(false); };

  return (
    <header className="header">
      <div className="container nav">
        <a href="/" className="brand" data-testid="header-logo">
          <img src={LOGO_URL_LIGHT} srcSet={`${LOGO_URL_LIGHT} 1x, /pniel-logo-header@2x.webp 2x`} alt="Pniel Analytics" width="240" height="100" />
        </a>

        <nav className="links">
          <div className="nav-item" data-testid="nav-services">
            <button type="button" className="nav-caret">Services <ChevronDown className="w-4 h-4" /></button>
            <div className="nav-dd">
              {SERVICE_LINKS.map((s) => (
                <a key={s.href} href={s.href} data-testid={`nav-svc-${s.slug}`}>{s.label}</a>
              ))}
            </div>
          </div>
          {NAV_LINKS.map((n) => (
            <a key={n.href} href={n.href} data-testid={`nav-${n.slug}`}>{n.label}</a>
          ))}
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <a className="button small" href={BOOK_CTA.href} onClick={() => trackAssessmentClick('header_desktop')} data-testid="header-book-btn">{BOOK_CTA.label}</a>
          <button className="menu" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      <div className={`mobile-nav ${open ? 'open' : ''}`}>
        <button type="button" className="mnav-group" onClick={() => setSvcOpen((s) => !s)} data-testid="mobile-services-toggle">
          Services <ChevronDown className={`w-4 h-4 mnav-caret ${svcOpen ? 'rot' : ''}`} />
        </button>
        {svcOpen && (
          <div className="mnav-sub">
            {SERVICE_LINKS.map((s) => (
              <a key={s.href} href={s.href} onClick={close} data-testid={`mnav-svc-${s.slug}`}>{s.label}</a>
            ))}
          </div>
        )}
        {NAV_LINKS.map((n) => (
          <a key={n.href} href={n.href} onClick={close} data-testid={`mnav-${n.slug}`}>{n.label}</a>
        ))}
        <a className="button" href={BOOK_CTA.href} onClick={() => { trackAssessmentClick('header_mobile'); close(); }} data-testid="mobile-book-btn">{BOOK_CTA.label}</a>
      </div>
    </header>
  );
};
